import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ButtonFav } from 'components/carousel/NewTooltip/ButtonFav';
import { converter } from '../../../helpers/converter';
import * as constants from '../../../constants';
import TooltipConstants from './constants';

const NewTooltip = props => {
  const { position, tooltipData, isFavorite, isLoading } = props.data;
  const dispP = !window.avoidTooltilTimer ? 'inital' : 'none';
  let flechaClass = null;
  if (position.xoffset && position.yoffset) {
    flechaClass = 'flecha-';
    flechaClass +=
      position.xoffset > 0 && !position.withRi ? 'left-' : 'right-';
    flechaClass += position.xoffset > 0 ? 'top' : 'bottom';
  }

  let divSerie = null;
  if (tooltipData.episode_number) {
    divSerie = (
      <div className="ToolTip-Serie">
        <div>
          {converter.convertApa(props.translations, TooltipConstants.EPISODE)}:{' '}
          <strong>{tooltipData.episode_number}</strong>
        </div>
        <div>
          {converter.convertApa(props.translations, TooltipConstants.SEASON)}:{' '}
          <strong>{tooltipData.season_number}</strong>
        </div>
        <div>
          {converter.convertApa(
            props.translations,
            TooltipConstants.COMMON_PUBLISHYEAR,
          )}
          :<strong>{tooltipData.year}</strong>
        </div>
      </div>
    );
  }

  const cardUrl = `/${constants.GetRegion()}/vcard/tercernivel/${
    tooltipData.title
  }
    /${tooltipData.id}`;

  return (
    <div
      onFocus={() => {}}
      onMouseOver={() => {
        props.handlerOverTooltip();
      }}
      onMouseLeave={() => {
        window.lastTooltipTarget = null;
        props.handlerLeaveTooltip();
      }}
      className="ToolTip-Container"
      style={{
        top: `${position.yoffset}px`,
        left: `${position.xoffset}px`,
        display: dispP,
      }}
    >
      <div className={flechaClass}> </div>
      <div className="ToolTip-Header">
        <div className="ToolTip-Title">
          <Link
            onClick={() => {
              setTimeout(() => {
                window.lastTooltipTarget = null;
                props.handlerLeaveTooltip();
              }, 500);
            }}
            to={cardUrl}
          >
            <h3>{tooltipData.title}</h3>
          </Link>
        </div>
        <div className="ToolTip-Info">
          <span>{tooltipData.year}</span>
          <span>{tooltipData.duration}</span>
          <span className="rate-tooltip"> </span>
        </div>
        <div className="ToolTip-Rate">{tooltipData.rating_code}</div>
      </div>
      <div className="ToolTip-Body">
        {divSerie}
        <div className="ToolTip-Desc">
          <strong>
            {converter.convertApa(
              props.translations,
              TooltipConstants.SYNOPSIS,
            )}
          </strong>
          {tooltipData.description_large}
        </div>
      </div>
      <div className="ToolTip-Footer">
        <div className="ToolTip-Buttons">
          {props.user.userhash && (
            <ButtonFav
              isFavorite={isFavorite}
              isLoading={isLoading}
              translations={props.translations}
              data={tooltipData}
              user={props.user}
              handlerAddFavorite={props.handlerAddFavorite}
              handlerDeleteFavorite={props.handlerDeleteFavorite}
            />
          )}
          <div className="ToolTip-Detalles">
            <Link
              onClick={() => {
                setTimeout(() => {
                  window.lastTooltipTarget = null;
                  props.handlerLeaveTooltip();
                }, 500);
              }}
              to={cardUrl}
            >
              {converter.convertApa(
                props.translations,
                TooltipConstants.MORE_INFO,
              )}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

NewTooltip.propTypes = {
  handlerLeaveTooltip: PropTypes.func,
  handlerDeleteFavorite: PropTypes.func,
  handlerAddFavorite: PropTypes.func,
  handlerOverTooltip: PropTypes.func,
  user: PropTypes.object,
  data: PropTypes.object,
  translations: PropTypes.object,
};

export default NewTooltip;
